var _mask, _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEykoJsonType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "EykoJsonType_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 13,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5.5h8.293L13.5 4.207V10.5h-12V.5z",
    stroke: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#EykoJsonType_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1 0h13v10H1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M9.5 0v5M14 4.5H9M0 15.5h3M2.5 11v5M4.5 11v2M6.5 14v2M4 11.5h3M4 13.5h3M4 15.5h3M8.5 11.5h2v4h-2zM12.5 11v5M14.5 11v5M12.538 11.195l1.923 4.612"
  })));
}

export default SvgEykoJsonType;